import "core-js/modules/es.array.concat.js";
import { sha256 } from "js-sha256";

var storeUserData = function storeUserData(usermail, userphone, userid) {
  var salt = "(*yc%Uf";
  var userMail = sha256("".concat(usermail).concat(salt));
  var userPhone = sha256("".concat(userphone).concat(salt));
  var userId = sha256("".concat(userid).concat(salt));
  window.sessionStorage.setItem("usermail", userMail);
  window.sessionStorage.setItem("userphone", userPhone);
  window.sessionStorage.setItem("userid", userId);
};

export default storeUserData;